// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { fetchFooterData, logoutUser } from '../../utils/apiService';

// const Header = () => {
//     const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//     const [headerData, setHeaderData] = useState(null);
//     const navigate = useNavigate();
//     const token = localStorage.getItem('token');

//     const handleLogout = async () => {
//         try {
//             if (token) {
//                 await logoutUser(token);
//             }
//         } catch (error) {
//             console.error('Logout API error:', error);
//         } finally {
//             localStorage.removeItem('token');
//             localStorage.removeItem('user');
//             navigate('/login');
//         }
//     };

//     useEffect(() => {
//         const getHeaderData = async () => {
//             const result = await fetchFooterData();
//             if (result && result.status) {
//                 setHeaderData(result.data);
//             }
//         };
//         getHeaderData();
//     }, []);

//     const toggleMobileMenu = () => {
//         setMobileMenuOpen(!mobileMenuOpen);
//     };

//     if (!headerData) return <div style={{ minHeight: '80px' }}></div>; // Placeholder while loading

//     return (
//         <>
//             {/* Top-bar */}
//             <div className="top-bar">
//                 <div className="top-bar-inner flex align-items-center justify-content-between">
//                     <div className="tf-tb-left">
//                         <ul className="list-topbar-item flex align-items-center">
//                             <li className="top-bar-item">
//                                 <i className="icon-location-dot"></i>
//                                 <a href="#" target="_blank" rel="noreferrer">{headerData.address}</a>
//                             </li>
//                             <li className="top-bar-item">
//                                 <i className="icon-email"></i>
//                                 <a href={`mailto:${headerData.email}`}>{headerData.email}</a>
//                             </li>
//                             <li className="top-bar-item">
//                                 <i className="icon-phone"></i>
//                                 <a href={`tel:${headerData.phone}`}>{headerData.phone}</a>
//                             </li>
//                         </ul>
//                     </div>

//                     <div className="tf-tb-right flex align-items-center">
//                         <ul className="post-social">
//                             {headerData.fb_link && (
//                                 <li>
//                                     <a href={headerData.fb_link} className="icon-social" target="_blank" rel="noreferrer">
//                                         <i className="icon-fb"></i>
//                                     </a>
//                                 </li>
//                             )}
//                             {headerData.instagram_link && (
//                                 <li>
//                                     <a href={headerData.instagram_link} className="icon-social" target="_blank" rel="noreferrer">
//                                         <i className="icon-instagram"></i>
//                                     </a>
//                                 </li>
//                             )}
//                             {headerData.x_link && (
//                                 <li>
//                                     <a href={headerData.x_link} className="icon-social" target="_blank" rel="noreferrer">
//                                         <i className="icon-X"></i>
//                                     </a>
//                                 </li>
//                             )}
//                             {headerData.tiktok_link && (
//                                 <li>
//                                     <a href={headerData.tiktok_link} className="icon-social" target="_blank" rel="noreferrer">
//                                         <i className="fa-brands fa-tiktok"></i>
//                                     </a>
//                                 </li>
//                             )}
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//             {/* /.top-bar */}

//             {/* Header */}
//             <header className="header header-sticky" id="header">
//                 <div className="header-content flex justify-content-between align-items-center">
//                     <div className="header-left flex align-items-center">
//                         <div className="logo logo-header">
//                             <Link to="/">
//                                 <img src={headerData.logo} alt={headerData.company_name} />
//                             </Link>
//                         </div>
//                         <nav className="main-menu">
//                             <ul className="menu-primary-menu">
//                                 <li className="menu-item">
//                                     <Link to="/" state={{ scrollTo: 'about' }} className="item-link body-2">
//                                         <span>About</span>
//                                     </Link>
//                                 </li>
//                                 <li className="menu-item">
//                                     <Link to="/services" className="item-link body-2">
//                                         <span>Services</span>
//                                     </Link>
//                                 </li>
//                                 <li className="menu-item">
//                                     <Link to="/bloglist" className="item-link body-2">
//                                         <span>Blogs</span>
//                                     </Link>
//                                 </li>
//                                 <li className="menu-item">
//                                     <Link to="/jobs" className="item-link body-2">
//                                         <span>Jobs</span>
//                                     </Link>
//                                 </li>

//                                 <li className="menu-item">
//                                     <Link to="/portfolio" className="item-link body-2">
//                                         <span>Portfolio</span>
//                                     </Link>
//                                 </li>
//                                  <li className="menu-item">
//                                 <Link to="/category" onClick={toggleMobileMenu}>Category</Link>
//                             </li>
//                                 {token ? (
//                                     <>
//                                         <li className="menu-item">
//                                             <Link to="/dashboard" className="item-link body-2">
//                                                 <span>Dashboard</span>
//                                             </Link>
//                                         </li>
//                                         <li className="menu-item">
//                                             <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }} className="item-link body-2">
//                                                 <span>Logout</span>
//                                             </a>
//                                         </li>
//                                     </>
//                                 ) : (
//                                     <>
//                                         <li className="menu-item">
//                                             <Link to="/login" className="item-link body-2">
//                                                 <span>Login</span>
//                                             </Link>
//                                         </li>
//                                         <li className="menu-item">
//                                             <Link to="/register" className="item-link body-2">
//                                                 <span>Register</span>
//                                             </Link>
//                                         </li>
//                                     </>
//                                 )}
//                                 <li className="menu-item">
//                                     <Link to="/contact" className="item-link body-2">
//                                         <span>Contact Us</span>
//                                     </Link>
//                                 </li>
//                             </ul>
//                         </nav>
//                     </div>
//                     <div className="header-right">
//                         <div className="mobile-button nav-item d-xl-none">
//                             <a onClick={toggleMobileMenu} className="btn-mobile-nav" href="#" role="button">
//                                 <span></span>
//                                 <span></span>
//                                 <span></span>
//                             </a>
//                         </div>
//                     </div>
//                 </div>
//             </header>
//             {/* /.header */}

//             {/* Mobile Menu Offcanvas */}
//             {/* Mobile Menu Offcanvas */}
//             {mobileMenuOpen && <div className="offcanvas-backdrop fade show" onClick={toggleMobileMenu}></div>}

//             <div className={`offcanvas offcanvas-start mobile-nav-wrap ${mobileMenuOpen ? 'show' : ''}`} id="canvasMobile" style={{ visibility: mobileMenuOpen ? 'visible' : 'hidden' }} aria-modal={mobileMenuOpen}>
//                 <div className="inner-mobile-nav">
//                     <div className="top-header-mobi">
//                         <div className="logo-mobile">
//                             <Link to="/">
//                                 <img src={headerData.logo} alt={headerData.company_name} />
//                             </Link>
//                         </div>
//                         <button className="mobile-nav-close" onClick={toggleMobileMenu} aria-label="Close">
//                             <svg xmlns="http://www.w3.org/2000/svg" fill="white" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 122.878 122.88" xmlSpace="preserve">
//                                 <g>
//                                     <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z">
//                                     </path>
//                                 </g>
//                             </svg>
//                         </button>
//                     </div>
//                     <nav className="mobile-main-nav">
//                         <ul id="menu-mobile" className="menu">
//                             <li className="menu-item">
//                                 <Link to="/" onClick={toggleMobileMenu}>Home</Link>
//                             </li>
//                             <li className="menu-item">
//                                 <Link to="/" state={{ scrollTo: 'about' }} onClick={toggleMobileMenu}>About</Link>
//                             </li>
//                             <li className="menu-item">
//                                 <Link to="/services" onClick={toggleMobileMenu}>Services</Link>
//                             </li>
//                             <li className="menu-item">
//                                 <Link to="/bloglist" onClick={toggleMobileMenu}>Blogs</Link>
//                             </li>
//                             <li className="menu-item">
//                                 <Link to="/jobs" onClick={toggleMobileMenu}>Jobs</Link>
//                             </li>
//                             <li className="menu-item">
//                                 <Link to="/portfolio" onClick={toggleMobileMenu}>Portfolio</Link>
//                             </li>
//                             <li className="menu-item">
//                                 <Link to="/category" onClick={toggleMobileMenu}>Category</Link>
//                             </li>
//                             {token ? (
//                                 <>
//                                     <li className="menu-item">
//                                         <Link to="/dashboard" onClick={toggleMobileMenu}>Dashboard</Link>
//                                     </li>
//                                     <li className="menu-item">
//                                         <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); toggleMobileMenu(); }}>Logout</a>
//                                     </li>
//                                 </>
//                             ) : (
//                                 <>
//                                     <li className="menu-item">
//                                         <Link to="/login" onClick={toggleMobileMenu}>Login</Link>
//                                     </li>
//                                     <li className="menu-item">
//                                         <Link to="/register" onClick={toggleMobileMenu}>Register</Link>
//                                     </li>
//                                 </>
//                             )}
//                             <li className="menu-item">
//                                 <Link to="/contact" onClick={toggleMobileMenu}>Contact Us</Link>
//                             </li>
//                         </ul>
//                         <div className="contact-mobile">
//                             <h5 className="title-contact-mobile">Contact Info</h5>
//                             <ul className="mb-20">
//                                 <li className="content-contact-moblile"><i className="icon-location-dot"></i> <a href="#" className="text-medium">{headerData.address}</a>
//                                 </li>
//                                 <li className="content-contact-moblile">
//                                     <i className="icon-email"></i><a href={`mailto:${headerData.email}`} className="text-medium">{headerData.email}</a>
//                                 </li>
//                                 <li className="content-contact-moblile">
//                                     <i className="icon-phone"></i><a href={`tel:${headerData.phone}`} className="text-medium">{headerData.phone}</a>
//                                 </li>
//                             </ul>

//                             <ul className="post-social">
//                                 {headerData.fb_link && (
//                                     <li>
//                                         <a href={headerData.fb_link} className="icon-social" target="_blank" rel="noreferrer">
//                                             <i className="icon-fb"></i>
//                                         </a>
//                                     </li>
//                                 )}
//                                 {headerData.instagram_link && (
//                                     <li>
//                                         <a href={headerData.instagram_link} className="icon-social" target="_blank" rel="noreferrer">
//                                             <i className="icon-instagram"></i>
//                                         </a>
//                                     </li>
//                                 )}
//                                 {headerData.x_link && (
//                                     <li>
//                                         <a href={headerData.x_link} className="icon-social" target="_blank" rel="noreferrer">
//                                             <i className="icon-X"></i>
//                                         </a>
//                                     </li>
//                                 )}
//                                 {headerData.tiktok_link && (
//                                     <li>
//                                         <a href={headerData.tiktok_link} className="icon-social" target="_blank" rel="noreferrer">
//                                             <i className="fa-brands fa-tiktok"></i>
//                                         </a>
//                                     </li>
//                                 )}
//                             </ul>
//                         </div>
//                     </nav>
//                 </div>
//             </div>
//             {/* /.mobile-nav-wrap */}
//         </>
//     );
// };

// export default Header;
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { fetchFooterData, logoutUser, getCart } from '../../utils/apiService';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [headerData, setHeaderData] = useState(null);
    const [cartCount, setCartCount] = useState(0);
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const handleLogout = async () => {
        try {
            if (token) {
                await logoutUser(token);
            }
        } catch (error) {
            console.error('Logout API error:', error);
        } finally {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            navigate('/login');
        }
    };

    useEffect(() => {
        const getHeaderData = async () => {
            const result = await fetchFooterData();
            if (result && result.status) {
                setHeaderData(result.data);
            }
        };

        const fetchCartCount = async () => {
            if (token) {
                const result = await getCart(token);
                if (result && result.status) {
                    // Safety check: ensure result.data is an array
                    const cartData = result.data || [];
                    const items = Array.isArray(cartData) ? cartData : (cartData.items && Array.isArray(cartData.items) ? cartData.items : []);

                    const count = items.reduce((total, item) => total + (item.quantity || 0), 0);
                    setCartCount(count);
                }
            }
        };

        getHeaderData();
        fetchCartCount();

        // Listen for custom event 'cartUpdated' to refresh count
        window.addEventListener('cartUpdated', fetchCartCount);
        return () => window.removeEventListener('cartUpdated', fetchCartCount);
    }, [token]);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    if (!headerData) return <div style={{ minHeight: '80px' }}></div>;

    return (
        <>
            {/* Top-bar */}
            <div className="top-bar">
                <div className="top-bar-inner flex align-items-center justify-content-between">
                    <div className="tf-tb-left">
                        <ul className="list-topbar-item flex align-items-center">
                            <li className="top-bar-item">
                                <i className="icon-location-dot"></i>
                                <a href="#" target="_blank" rel="noreferrer">{headerData.address}</a>
                            </li>
                            <li className="top-bar-item">
                                <i className="icon-email"></i>
                                <a href={`mailto:${headerData.email}`}>{headerData.email}</a>
                            </li>
                            <li className="top-bar-item">
                                <i className="icon-phone"></i>
                                <a href={`tel:${headerData.phone}`}>{headerData.phone}</a>
                            </li>
                        </ul>
                    </div>

                    <div className="tf-tb-right flex align-items-center">
                        <ul className="post-social">
                            {headerData.fb_link && (
                                <li>
                                    <a href={headerData.fb_link} className="icon-social" target="_blank" rel="noreferrer">
                                        <i className="icon-fb"></i>
                                    </a>
                                </li>
                            )}
                            {headerData.instagram_link && (
                                <li>
                                    <a href={headerData.instagram_link} className="icon-social" target="_blank" rel="noreferrer">
                                        <i className="icon-instagram"></i>
                                    </a>
                                </li>
                            )}
                            {headerData.x_link && (
                                <li>
                                    <a href={headerData.x_link} className="icon-social" target="_blank" rel="noreferrer">
                                        <i className="icon-X"></i>
                                    </a>
                                </li>
                            )}
                            {headerData.tiktok_link && (
                                <li>
                                    <a href={headerData.tiktok_link} className="icon-social" target="_blank" rel="noreferrer">
                                        <i className="fa-brands fa-tiktok"></i>
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            {/* /.top-bar */}

            {/* Header */}
            <header className="header header-sticky" id="header">
                <div className="header-content flex justify-content-between align-items-center">
                    <div className="header-left flex align-items-center">
                        <div className="logo logo-header">
                            <Link to="/">
                                <img src={headerData.logo} alt={headerData.company_name} />
                            </Link>
                        </div>
                        <nav className="main-menu">
                            <ul className="menu-primary-menu">
                                <li className="menu-item">
                                    <Link to="/" state={{ scrollTo: 'about' }} className="item-link body-2">
                                        <span>About</span>
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link to="/services" className="item-link body-2">
                                        <span>Services</span>
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link to="/bloglist" className="item-link body-2">
                                        <span>Blogs</span>
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link to="/jobs" className="item-link body-2">
                                        <span>Jobs</span>
                                    </Link>
                                </li>

                                <li className="menu-item">
                                    <Link to="/portfolio" className="item-link body-2">
                                        <span>Portfolio</span>
                                    </Link>
                                </li>
                                <li className="menu-item">
                                    <Link to="/item" className="item-link body-2">
                                        <span>Items</span>
                                    </Link>
                                </li>
                                {/* {!token && (
                                    <>
                                        <li className="menu-item">
                                            <Link to="/login" className="item-link body-2">
                                                <span>Login</span>
                                            </Link>
                                        </li>
                                        <li className="menu-item">
                                            <Link to="/register" className="item-link body-2">
                                                <span>Register</span>
                                            </Link>
                                        </li>
                                    </>
                                )} */}
                                <li className="menu-item">
                                    <Link to="/contact" className="item-link body-2">
                                        <span>Contact Us</span>
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="header-right">
                        <div className="nav-btn header-set-cart">
                            {token ? (
                                <div className="user-dropdown">
                                    <a href="#" className="user-icon">
                                        <i className="fa-solid fa-user"></i>
                                    </a>

                                    <ul className="user-menu">
                                        <li>
                                            <Link to="/dashboard">Profile</Link>
                                        </li>
                                        <li>
                                            <Link to="/orderhistory">My Orders</Link>
                                        </li>
                                        <li className="divider"></li>
                                        <li>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Logout</a>
                                        </li>
                                    </ul>
                                </div>
                            ) : (
                                <a href="#" onClick={(e) => { e.preventDefault(); navigate('/login'); }}>
                                    <i className="fa-solid fa-user"></i>
                                </a>
                            )}
                            <div className="relative btn-spacing">
                                <Link to="/cart" className="shopping-cart-size">
                                    <i className="fa fa-shopping-cart" aria-hidden="true"><span className="shop-badge" id="totalitemincart">{cartCount}</span></i>
                                </Link>
                            </div>
                        </div>
                        <div className="mobile-button nav-item d-xl-none">
                            <a onClick={toggleMobileMenu} className="btn-mobile-nav" href="#" role="button">
                                <span></span>
                                <span></span>
                                <span></span>
                            </a>
                        </div>
                    </div>
                </div>
            </header>
            {/* /.header */}

            {/* Mobile Menu Offcanvas */}
            {/* Mobile Menu Offcanvas */}
            {mobileMenuOpen && <div className="offcanvas-backdrop fade show" onClick={toggleMobileMenu}></div>}

            <div className={`offcanvas offcanvas-start mobile-nav-wrap ${mobileMenuOpen ? 'show' : ''}`} id="canvasMobile" style={{ visibility: mobileMenuOpen ? 'visible' : 'hidden' }} aria-modal={mobileMenuOpen}>
                <div className="inner-mobile-nav">
                    <div className="top-header-mobi">
                        <div className="logo-mobile">
                            <Link to="/">
                                <img src={headerData.logo} alt={headerData.company_name} />
                            </Link>
                        </div>
                        <button className="mobile-nav-close" onClick={toggleMobileMenu} aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="white" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 122.878 122.88" xmlSpace="preserve">
                                <g>
                                    <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z">
                                    </path>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <nav className="mobile-main-nav">
                        <ul id="menu-mobile" className="menu">
                            <li className="menu-item">
                                <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/" state={{ scrollTo: 'about' }} onClick={toggleMobileMenu}>About</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/services" onClick={toggleMobileMenu}>Services</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/bloglist" onClick={toggleMobileMenu}>Blogs</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/jobs" onClick={toggleMobileMenu}>Jobs</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/portfolio" onClick={toggleMobileMenu}>Portfolio</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/item" onClick={toggleMobileMenu}>Items</Link>
                            </li>
                            {token ? (
                                <>
                                    <li className="menu-item">
                                        <Link to="/dashboard" onClick={toggleMobileMenu}>Profile</Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/orderhistory" onClick={toggleMobileMenu}>My Orders</Link>
                                    </li>
                                    <li className="menu-item">
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); toggleMobileMenu(); }}>Logout</a>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li className="menu-item">
                                        <Link to="/login" onClick={toggleMobileMenu}>Login</Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/register" onClick={toggleMobileMenu}>Register</Link>
                                    </li>
                                </>
                            )}
                            <li className="menu-item">
                                <Link to="/contact" onClick={toggleMobileMenu}>Contact Us</Link>
                            </li>
                        </ul>
                        <div className="contact-mobile">
                            <h5 className="title-contact-mobile">Contact Info</h5>
                            <ul className="mb-20">
                                <li className="content-contact-moblile"><i className="icon-location-dot"></i> <a href="#" className="text-medium">{headerData.address}</a>
                                </li>
                                <li className="content-contact-moblile">
                                    <i className="icon-email"></i><a href={`mailto:${headerData.email}`} className="text-medium">{headerData.email}</a>
                                </li>
                                <li className="content-contact-moblile">
                                    <i className="icon-phone"></i><a href={`tel:${headerData.phone}`} className="text-medium">{headerData.phone}</a>
                                </li>
                            </ul>

                            <ul className="post-social">
                                {headerData.fb_link && (
                                    <li>
                                        <a href={headerData.fb_link} className="icon-social" target="_blank" rel="noreferrer">
                                            <i className="icon-fb"></i>
                                        </a>
                                    </li>
                                )}
                                {headerData.instagram_link && (
                                    <li>
                                        <a href={headerData.instagram_link} className="icon-social" target="_blank" rel="noreferrer">
                                            <i className="icon-instagram"></i>
                                        </a>
                                    </li>
                                )}
                                {headerData.x_link && (
                                    <li>
                                        <a href={headerData.x_link} className="icon-social" target="_blank" rel="noreferrer">
                                            <i className="icon-X"></i>
                                        </a>
                                    </li>
                                )}
                                {headerData.tiktok_link && (
                                    <li>
                                        <a href={headerData.tiktok_link} className="icon-social" target="_blank" rel="noreferrer">
                                            <i className="fa-brands fa-tiktok"></i>
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
            {/* /.mobile-nav-wrap */}
        </>
    );
};

export default Header;